<template>
  <ThreeColumnLayout>
    <main class="page">
      <p class="page__placeholder">Participation validée — contenu à intégrer</p>
    </main>
  </ThreeColumnLayout>
</template>

<script>
import ThreeColumnLayout from "@/components/ThreeColumnLayout.vue";

export default {
  name: "ParticipationValideeView",
  components: {
    ThreeColumnLayout,
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 1.5rem 1rem;
}

.page__placeholder {
  margin: 0;
  text-align: center;
  color: #444;
}
</style>
